import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useToast } from 'hooks/ui';
import { useApplicationStore } from 'store/application';
import { createUserRolesForAGroup } from 'api/userGroups.service';
import { userGroupsKeys } from './queryKeys';

export const useCreateUserRolesForAGroup = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore((state) => state);

  const { isPending, mutate, data } = useMutation({
    mutationFn: (info: { userGroupId: string; rolesList: Array<string> }) => {
      setLoading();

      return createUserRolesForAGroup(info.userGroupId, info.rolesList);
    },
    onSuccess: () => {
      toast.success('Roles have been created successfully');
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: () => {
      removeLoading();
      queryClient.invalidateQueries({ queryKey: userGroupsKeys.all });
    },
  });

  return { isLoading: isPending, mutate, data };
};
